module.exports = __webpack_public_path__ + "img/icon-hs-video.82d464d1.svg";